import i18n from 'l10n';
import JEditable from 'jqueryEditable';
import DefaultEditable from "./default.editable";

//@Override buttons of jEditable and add the `add custom tag` button
class CustomTagEditable extends DefaultEditable {
    buttons(settings, original) {
        var form = this;
        var submit;
        var cancel;
        if (settings.submit) {
            /* if given html string use that */
            if (settings.submit.match(/>$/)) {
                submit = $(settings.submit).click(function () {
                    if (submit.attr("type") !== "submit") {
                        form.submit();
                    }
                });
                /* otherwise use button with given string as text */
            } else {
                submit = $(`<button class="bg-hover-emerald fg-hover-white" title="${i18n.t("message.savemail")}" type="submit" />`);
                submit.html(settings.submit);
            }
            $(this).append(submit);
        }
        if (settings.cancel) {
            /* if given html string use that */
            if (settings.cancel.match(/>$/)) {
                cancel = $(settings.cancel);
                /* otherwise use button with given string as text */
            } else {
                cancel = $(`<button class="bg-hover-red fg-hover-white" title="${i18n.t("cancelbtn")}" type="reset" />`);
                cancel.html(settings.cancel);
            }
            $(this).append(cancel);

            $(cancel).click(function (event) {
                original.cancelsubmit(event);
                //original.reset();
                const reset = new JEditable.types[settings.type]().reset;
                reset.apply(form, [settings, original]);
                return false;
            });
        }


        /**  CUSTOM TAG - START  **/
        if (settings.customTag) {
            var customTagButtons;
            /* if given html string use that */
            if (settings.customTag.value.match(/>$/)) {
                customTagButtons = $(settings.customTag.value);
                /* otherwise use button with given string as text */
            } else {
                showCustomTagsForSelection(this, form, settings);
            }
            $(this).append(customTagButtons);


            $($(form).find(".customTag")).unbind().on("click", function (event) {
                //needed to disable form submission
                event.stopPropagation();
                event.preventDefault();

                var customTagValue = $(event.currentTarget).data("value");
                var elementToAddTag = settings.type === "textarea" ? $($(form).find("textarea")) : $($(form).find("input"));
                addCustomTagIn(customTagValue, elementToAddTag);

                if (settings.type === "textarea") {
                    //change textareas' number of rows according to its content.
                    var textareaWidth = $(elementToAddTag).width();
                    //append a new span in the `body` and get the text's width. Now we can see how many rows this text needs in the textarea
                    var newSpan = $("<span />");
                    newSpan.css({
                        "font-size": $(elementToAddTag).css("font-size")
                    });

                    //set the `text` of span to get a single line's height
                    newSpan.text($(elementToAddTag).val());
                    $('body').append(newSpan); //append it, or else its width will be undefined.
                    var singleLineHeight = newSpan.height();

                    //set the `html` of span to get the total height of the element (including the `<br/>`)
                    newSpan.html($(elementToAddTag).val());

                    // `textWidth` is the width of the textarea's value in a single row.
                    var textWidth = newSpan.width();
                    newSpan.remove(); //remove it since it is not needed any more

                    //get the ratio of `text's (one-line) width` and `textarea's width`, and find how many rows the textarea needs
                    var numberOfRows = parseInt(textareaWidth === 0 ? 1 : (textWidth / textareaWidth) + 1); //to include the first one add `1`
                    var rowsAttribute = parseInt($(elementToAddTag).attr("rows")); //value of `rows` attribute

                    //change the `rows` attribute value, with the bigger value between `numberOfLines` and `rowsAttribute`
                    var biggerNumb = numberOfRows > rowsAttribute ? numberOfRows : rowsAttribute;
                    $(elementToAddTag).attr("rows", biggerNumb);
                    $(elementToAddTag).css("height", (singleLineHeight * biggerNumb) + "px");
                }
            });
        }
        /**  CUSTOM TAG - END  **/
    }
}

var showCustomTagsForSelection = function (self, form, settings) {
    var customTags = [
        {text: i18n.t("subscriber.firstname"), value: "firstName", icon: "icon-tellody-user"},
        {text: i18n.t("subscriber.lastname"), value: "lastName", icon: "icon-tellody-user"},
        {text: i18n.t("subscriber.firstname_voc"), value: "name_voc", icon: "icon-tellody-user"},
        {text: i18n.t("subscriber.lastname_voc"), value: "surname_voc", icon: "icon-tellody-user"},
        {text: i18n.t("subscriber.profession"), value: "profession", icon: "icon-briefcase"},
        {text: i18n.t("subscriber.address"), value: "address", icon: "icon-home"},
        {text: i18n.t("subscriber.email"), value: "email", icon: "icon-tellody-message"},
        {text: i18n.t("subscriber.mobile"), value: "mobile", icon: "icon-mobile-2"}
    ];
    $.ajaxDefaultQ({
        url: '/CampaignCloud/CustomFields'
    }).done(function (response) {
        $.each(response, function (index, customField) {
            customTags.push({text: customField.name, value: "customfield" + customField.id, icon: ""});
        });
        var contentToReturn = "";
        $.each(customTags, function (index, tag) {
            if (i18n.language !== "el") {
                if (["name_voc", "surname_voc"].indexOf(tag.value) === -1) {
                    contentToReturn += `<button data-value="${tag.value}" class="customTag button large fg-white"><i class="${tag.icon}" style="margin-right:5px;"></i>${tag.text}</button>`;
                }
            } else {
                contentToReturn += `<button data-value="${tag.value}" class="customTag button large fg-white"><i class="${tag.icon}" style="margin-right:5px;"></i>${tag.text}</button>`;
            }
        });
        var customTagButtons = $('<div />');
        customTagButtons.html(contentToReturn);
        $(self).append(customTagButtons);
        addEvent(form, settings);
    }).fail(function (response) {
        console.error(response);
    });
};

var addEvent = function (form, settings) {
    $($(form).find(".customTag")).unbind().on("click", function (event) {
        //needed to disable form submission
        event.stopPropagation();
        event.preventDefault();

        var customTagValue = $(event.currentTarget).data("value");
        var elementToAddTag = settings.type === "textarea" ? $($(form).find("textarea")) : $($(form).find("input"));
        addCustomTagIn(customTagValue, elementToAddTag);

        if (settings.type === "textarea") {
            //change textareas' number of rows according to its content.
            var numberOfLines = $(elementToAddTag).val().split("\n").length; //number of lines in the textarea, splited by "\n"
            var rowsAttribute = parseInt($(elementToAddTag).attr("rows")); //value of `rows` attribute
            //change the `rows` attribute value, with the bigger value between `numberOfLines` and `rowsAttribute`
            var biggerNumb = numberOfLines > rowsAttribute ? numberOfLines : rowsAttribute;
            $(elementToAddTag).attr("rows", biggerNumb);
        }
    });
};

//custom functions
var insertAtCaret = function (inputOrTexArea, text) {
    if (!inputOrTexArea) {
        return;
    }

    var scrollPos = inputOrTexArea.scrollTop();
    var strPos = 0;
    var br = ((inputOrTexArea[0].selectionStart || inputOrTexArea[0].selectionStart === '0') ?
        "ff" : (document.selection ? "ie" : false));
    if (br === "ie") {
        inputOrTexArea.focus();
        var range = document.selection.createRange();
        range.moveStart('character', -inputOrTexArea.val().length);
        strPos = range.text.length;
    } else if (br === "ff") {
        strPos = inputOrTexArea[0].selectionStart;
    }

    var front = (inputOrTexArea.val()).substring(0, strPos);
    var back = (inputOrTexArea.val()).substring(strPos, inputOrTexArea.val().length);

    inputOrTexArea.val(front + text + back);
    strPos = strPos + text.length;
    if (br === "ie") {
        inputOrTexArea.focus();
        var ieRange = document.selection.createRange();
        ieRange.moveStart('character', -inputOrTexArea.val().length);
        ieRange.moveStart('character', strPos);
        ieRange.moveEnd('character', 0);
        ieRange.select();
    } else if (br === "ff") {
        inputOrTexArea[0].selectionStart = strPos;
        inputOrTexArea[0].selectionEnd = strPos;
        inputOrTexArea.focus();
    }

    inputOrTexArea.scrollTop(scrollPos);
};

var addCustomTagIn = function (customTag, element) {
    const fieldTagMapping = {
        "address": "{subscriber.address}",
        "firstName": "{subscriber.name}",
        "lastName": "{subscriber.surname}",
        "profession": "{subscriber.profession}",
        "name_voc": "{subscriber.name_voc}",
        "surname_voc": "{subscriber.surname_voc}",
        "email": "{subscriber.email}",
        "mobile": "{subscription.msisdn}",
        "customfield1": "{customfield1}",
        "customfield2": "{customfield2}",
        "customfield3": "{customfield3}",
        "customfield4": "{customfield4}",
        "customfield5": "{customfield5}",
        "customfield6": "{customfield6}",
        "customfield7": "{customfield7}",
        "customfield8": "{customfield8}",
        "customfield9": "{customfield9}",
        "customfield10": "{customfield10}"
    };
    const tagToAdd = fieldTagMapping[customTag];
    if (element.val().indexOf(tagToAdd) > -1) {
        $.Notify.show(i18n.t("voucher.alreadyAddedCustomTag"));
        return; //do not add a tag, if it already exists
    }
    //add custom tag on the caret's position
    insertAtCaret(element, tagToAdd);
};

export default CustomTagEditable;